// extracted by mini-css-extract-plugin
export default {"contactDetails":"styles_contactDetails__dK2rk","phone":"styles_phone__q1BGG"};